const ensureTailingSlash = (s: string): string => (s.endsWith('/') ? s : s + '/')
export default ensureTailingSlash
